// extracted by mini-css-extract-plugin
export default {"content":"InfoGeneral_content__+004e","first-field":"InfoGeneral_first-field__Yj9SL","second-fields":"InfoGeneral_second-fields__0De8r"};